//# sourceMappingURL=answer.mjs.map
/// <reference types="./answer.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $assoc from "../../../tiamat/gleam/assoc.mjs";
import * as $json_ from "../../../tiamat/gleam/json_.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $data_point from "../../data/data_point.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Long extends $CustomType {}
export const AnswerKind$Long = () => new Long();
export const AnswerKind$isLong = (value) => value instanceof Long;

export class YesNo extends $CustomType {}
export const AnswerKind$YesNo = () => new YesNo();
export const AnswerKind$isYesNo = (value) => value instanceof YesNo;

export class MultipleChoice extends $CustomType {}
export const AnswerKind$MultipleChoice = () => new MultipleChoice();
export const AnswerKind$isMultipleChoice = (value) =>
  value instanceof MultipleChoice;

export class HumanWritting extends $CustomType {}
export const WrittingMethod$HumanWritting = () => new HumanWritting();
export const WrittingMethod$isHumanWritting = (value) =>
  value instanceof HumanWritting;

export class AiFirstGeneration extends $CustomType {}
export const WrittingMethod$AiFirstGeneration = () => new AiFirstGeneration();
export const WrittingMethod$isAiFirstGeneration = (value) =>
  value instanceof AiFirstGeneration;

export class AiImprove extends $CustomType {}
export const WrittingMethod$AiImprove = () => new AiImprove();
export const WrittingMethod$isAiImprove = (value) => value instanceof AiImprove;

export class Rollback extends $CustomType {}
export const WrittingMethod$Rollback = () => new Rollback();
export const WrittingMethod$isRollback = (value) => value instanceof Rollback;

/**
 * Written by a model outside Steerlab, through the Mimir MCP server. Kept
 * distinct from `AiFirstGeneration` so reviewers can tell content produced by
 * Steerlab's own pipeline from content a third-party assistant proposed.
 */
export class ExternalLlm extends $CustomType {}
export const WrittingMethod$ExternalLlm = () => new ExternalLlm();
export const WrittingMethod$isExternalLlm = (value) =>
  value instanceof ExternalLlm;

export class AnswerV2 extends $CustomType {
  constructor(id, element_id, answer_id, value, kind, metadata, version, created_at) {
    super();
    this.id = id;
    this.element_id = element_id;
    this.answer_id = answer_id;
    this.value = value;
    this.kind = kind;
    this.metadata = metadata;
    this.version = version;
    this.created_at = created_at;
  }
}
export const AnswerV2$AnswerV2 = (id, element_id, answer_id, value, kind, metadata, version, created_at) =>
  new AnswerV2(id,
  element_id,
  answer_id,
  value,
  kind,
  metadata,
  version,
  created_at);
export const AnswerV2$isAnswerV2 = (value) => value instanceof AnswerV2;
export const AnswerV2$AnswerV2$id = (value) => value.id;
export const AnswerV2$AnswerV2$0 = (value) => value.id;
export const AnswerV2$AnswerV2$element_id = (value) => value.element_id;
export const AnswerV2$AnswerV2$1 = (value) => value.element_id;
export const AnswerV2$AnswerV2$answer_id = (value) => value.answer_id;
export const AnswerV2$AnswerV2$2 = (value) => value.answer_id;
export const AnswerV2$AnswerV2$value = (value) => value.value;
export const AnswerV2$AnswerV2$3 = (value) => value.value;
export const AnswerV2$AnswerV2$kind = (value) => value.kind;
export const AnswerV2$AnswerV2$4 = (value) => value.kind;
export const AnswerV2$AnswerV2$metadata = (value) => value.metadata;
export const AnswerV2$AnswerV2$5 = (value) => value.metadata;
export const AnswerV2$AnswerV2$version = (value) => value.version;
export const AnswerV2$AnswerV2$6 = (value) => value.version;
export const AnswerV2$AnswerV2$created_at = (value) => value.created_at;
export const AnswerV2$AnswerV2$7 = (value) => value.created_at;

export class Metadata extends $CustomType {
  constructor(choices, position, score, explanation, context_used, editor, writing_method, rollback, version) {
    super();
    this.choices = choices;
    this.position = position;
    this.score = score;
    this.explanation = explanation;
    this.context_used = context_used;
    this.editor = editor;
    this.writing_method = writing_method;
    this.rollback = rollback;
    this.version = version;
  }
}
export const Metadata$Metadata = (choices, position, score, explanation, context_used, editor, writing_method, rollback, version) =>
  new Metadata(choices,
  position,
  score,
  explanation,
  context_used,
  editor,
  writing_method,
  rollback,
  version);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$choices = (value) => value.choices;
export const Metadata$Metadata$0 = (value) => value.choices;
export const Metadata$Metadata$position = (value) => value.position;
export const Metadata$Metadata$1 = (value) => value.position;
export const Metadata$Metadata$score = (value) => value.score;
export const Metadata$Metadata$2 = (value) => value.score;
export const Metadata$Metadata$explanation = (value) => value.explanation;
export const Metadata$Metadata$3 = (value) => value.explanation;
export const Metadata$Metadata$context_used = (value) => value.context_used;
export const Metadata$Metadata$4 = (value) => value.context_used;
export const Metadata$Metadata$editor = (value) => value.editor;
export const Metadata$Metadata$5 = (value) => value.editor;
export const Metadata$Metadata$writing_method = (value) => value.writing_method;
export const Metadata$Metadata$6 = (value) => value.writing_method;
export const Metadata$Metadata$rollback = (value) => value.rollback;
export const Metadata$Metadata$7 = (value) => value.rollback;
export const Metadata$Metadata$version = (value) => value.version;
export const Metadata$Metadata$8 = (value) => value.version;

export const answer_type_version = 2;

export function writting_method_decoder() {
  return $decode.then$(
    $decode.string,
    (variant) => {
      if (variant === "human_writting") {
        return $decode.success(new HumanWritting());
      } else if (variant === "ai_first_generation") {
        return $decode.success(new AiFirstGeneration());
      } else if (variant === "ai_improve") {
        return $decode.success(new AiImprove());
      } else if (variant === "rollback") {
        return $decode.success(new Rollback());
      } else if (variant === "external_llm") {
        return $decode.success(new ExternalLlm());
      } else {
        return $decode.failure(new HumanWritting(), "WrittingMethod");
      }
    },
  );
}

export function position_decoder() {
  return $decode.field(
    "x",
    $decode.int,
    (x) => {
      return $decode.field(
        "y",
        $decode.int,
        (y) => { return $decode.success([x, y]); },
      );
    },
  );
}

export function metadata_decoder() {
  return $decode.field(
    "version",
    $decode.int,
    (version) => {
      return $decrypt.optional_field(
        "position",
        position_decoder(),
        (position) => {
          return $decrypt.optional_field(
            "choices",
            $decode.list($decode.string),
            (choices) => {
              return $decrypt.optional_field(
                "score",
                $decrypt.float(),
                (score) => {
                  return $decrypt.optional_field(
                    "explanation",
                    $decode.string,
                    (explanation) => {
                      return $decrypt.optional_field(
                        "context_used",
                        $data_point.ids_decoder(),
                        (context_used) => {
                          return $decode.field(
                            "editor",
                            $decode.string,
                            (editor) => {
                              return $decode.field(
                                "writing_method",
                                writting_method_decoder(),
                                (writing_method) => {
                                  return $decrypt.optional_field(
                                    "rollback",
                                    $decode.string,
                                    (rollback) => {
                                      let _block;
                                      let _pipe = context_used;
                                      _block = $option.unwrap(_pipe, toList([]));
                                      let context_used$1 = _block;
                                      return $decode.success(
                                        new Metadata(
                                          choices,
                                          position,
                                          score,
                                          explanation,
                                          context_used$1,
                                          editor,
                                          writing_method,
                                          rollback,
                                          version,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function answer_kind_decoder() {
  return $decode.then$(
    $decode.string,
    (answer_kind) => {
      if (answer_kind === "long") {
        return $decode.success(new Long());
      } else if (answer_kind === "short") {
        return $decode.success(new Long());
      } else if (answer_kind === "custom") {
        return $decode.success(new Long());
      } else if (answer_kind === "textual-answer") {
        return $decode.success(new Long());
      } else if (answer_kind === "textual_answer") {
        return $decode.success(new Long());
      } else if (answer_kind === "unknown") {
        return $decode.success(new Long());
      } else if (answer_kind === "yes-no") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes_no") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes_no_answer") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "yes-no-answer") {
        return $decode.success(new YesNo());
      } else if (answer_kind === "multiple-choice") {
        return $decode.success(new MultipleChoice());
      } else if (answer_kind === "choice") {
        return $decode.success(new MultipleChoice());
      } else {
        return $decode.failure(new Long(), "AnswerKind");
      }
    },
  );
}

export function answer_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "element_id",
        $decode.string,
        (element_id) => {
          return $decode.field(
            "answer_id",
            $decode.string,
            (answer_id) => {
              return $decode.field(
                "value",
                $decode.string,
                (value) => {
                  return $decode.field(
                    "kind",
                    answer_kind_decoder(),
                    (kind) => {
                      return $decode.field(
                        "metadata",
                        $decrypt.json(metadata_decoder()),
                        (metadata) => {
                          return $decode.field(
                            "version",
                            $decode.int,
                            (version) => {
                              return $decode.field(
                                "created_at",
                                $decrypt.timestamp(),
                                (created_at) => {
                                  return $decode.success(
                                    new AnswerV2(
                                      id,
                                      element_id,
                                      answer_id,
                                      value,
                                      kind,
                                      metadata,
                                      version,
                                      created_at,
                                    ),
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function writting_method_to_string(writting_method) {
  if (writting_method instanceof HumanWritting) {
    return "human_writting";
  } else if (writting_method instanceof AiFirstGeneration) {
    return "ai_first_generation";
  } else if (writting_method instanceof AiImprove) {
    return "ai_improve";
  } else if (writting_method instanceof Rollback) {
    return "rollback";
  } else {
    return "external_llm";
  }
}

export function encode_writting_method(writting_method) {
  return $json.string(writting_method_to_string(writting_method));
}

export function answer_kind_to_string(q) {
  if (q instanceof Long) {
    return "long";
  } else if (q instanceof YesNo) {
    return "yes-no";
  } else {
    return "multiple-choice";
  }
}

export function encode_answer_kind(q) {
  let _pipe = answer_kind_to_string(q);
  return $json.string(_pipe);
}

function encode_position(position) {
  return $json.object(
    toList([["x", $json.int(position[0])], ["y", $json.int(position[1])]]),
  );
}

export function encode_metadata(metadata) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.int(_pipe, "version", metadata.version);
  let _pipe$2 = $json_.optional_float(_pipe$1, "score", metadata.score);
  let _pipe$3 = $json_.string(_pipe$2, "editor", metadata.editor);
  let _pipe$4 = $json_.json(
    _pipe$3,
    "writing_method",
    encode_writting_method(metadata.writing_method),
  );
  let _pipe$5 = $json_.optional_string(
    _pipe$4,
    "explanation",
    metadata.explanation,
  );
  let _pipe$6 = $json_.optional_json(
    _pipe$5,
    "choices",
    (() => {
      let _pipe$6 = metadata.choices;
      return $option.map(
        _pipe$6,
        (_capture) => { return $json.array(_capture, $json.string); },
      );
    })(),
  );
  let _pipe$7 = $json_.optional_json(
    _pipe$6,
    "position",
    (() => {
      let _pipe$7 = metadata.position;
      return $option.map(_pipe$7, encode_position);
    })(),
  );
  let _pipe$8 = $json_.json(
    _pipe$7,
    "context_used",
    $data_point.ids_encode(metadata.context_used),
  );
  let _pipe$9 = $json_.optional_string(_pipe$8, "rollback", metadata.rollback);
  return $json_.to_json(_pipe$9);
}

export function encode(answer) {
  let _pipe = $json_.empty();
  let _pipe$1 = $json_.string(_pipe, "id", answer.id);
  let _pipe$2 = $json_.string(_pipe$1, "value", answer.value);
  let _pipe$3 = $json_.int(_pipe$2, "version", answer.version);
  let _pipe$4 = $json_.string(_pipe$3, "answer_id", answer.answer_id);
  let _pipe$5 = $json_.string(_pipe$4, "element_id", answer.element_id);
  let _pipe$6 = $json_.json(_pipe$5, "kind", encode_answer_kind(answer.kind));
  let _pipe$7 = $json_.json(
    _pipe$6,
    "metadata",
    encode_metadata(answer.metadata),
  );
  let _pipe$8 = $json_.json(
    _pipe$7,
    "created_at",
    $timestamp_.encode(answer.created_at),
  );
  return $json_.to_json(_pipe$8);
}
